(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('manualActionSaveConverter', ["$q", "actionTagsProcessor", function ($q, actionTagsProcessor) {
        return function (input, args) {
            var deferred = $q.defer();
            actionTagsProcessor.generateTags(input.data, input.data.attributes);
            deferred.resolve(input);
            return deferred.promise;
        };
    }]);
}());